import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface SalesRep{
  id?: number;
  name: string;
  email: string;
  phone: String;
}


@Injectable({
  providedIn: 'root'
})
export class SalesRepService {

  Path: string = '/api/v1/sales-rep';

  sales: SalesRep[] ;
  constructor(private httpClient:HttpClient) { }


  getSalesRep(): Observable<SalesRep[]>{
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<SalesRep[]>( this.Path+'/' , {headers}).pipe(catchError(this.errorHandler));
  }

  getSalesRepById(id): Observable<SalesRep>{


    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<SalesRep>(this.Path +'/' + id ,{headers}).pipe(catchError(this.errorHandler));
  }

  addSalesRep(salesRep):Observable<SalesRep>{
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<SalesRep>(this.Path+'/', salesRep ,{headers}).pipe(catchError(this.errorHandler));
  }

  updateSalesRep(id, salesRep){
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.put(this.Path + '/' + id, salesRep ,{headers}).pipe(catchError(this.errorHandler));
  }

  deleteSalesRep(id){
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.delete(this.Path + '/' + id , {headers}).pipe(catchError(this.errorHandler));
  }


  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }
}
